import { o as parseJsonResponse, J as getCTAClickEventParams } from './index-e29b327a.js';
import { t as triggerCtaClickEvent, s as send, j as downloadDocumentEvent, u as onlineSoftwareModalClickEvent } from './analytics-b6a65ffa.js';

const requestRangeSelectorConfig = (host, rangeId, spryKerConfigs) => {
  let url = `${host}product/range/selector-config/${rangeId}`;
  if (spryKerConfigs) {
    url = `${host}/ranges/${rangeId}/selector-config?country-code=${spryKerConfigs.countryCode}&language-code=${spryKerConfigs.languageCode}&brand=${spryKerConfigs.brand}`;
  }
  return fetch(url).then((response) => parseJsonResponse(response));
};
const addRangeClickGAEvent = (item, position) => {
  const { name, category, url } = item;
  const ctaClickGAParams = getCTAClickEventParams(name, category, url, position);
  triggerCtaClickEvent(ctaClickGAParams);
};
const onDownloadLinkClickGA = (row, ctaItem, position) => {
  const { reference, fileName, docType, url } = row;
  const item = Object.assign(Object.assign({}, ctaItem), { url });
  addRangeClickGAEvent(item, position);
  if (reference || fileName || docType) {
    send(downloadDocumentEvent, {
      documentReference: reference,
      documentName: fileName,
      documentType: docType,
    });
  }
};
const getPriorityNumber = (numberOfButtonsBefore) => {
  if (numberOfButtonsBefore === 0)
    return 1;
  if (numberOfButtonsBefore === 1)
    return 2;
  if (numberOfButtonsBefore >= 2)
    return 3;
};
const onSoftwareDocumentDialogClick = (type, additionLinks, labels, ctaItem, position) => {
  const { areaTitle } = labels;
  const softwareModal = document.createElement('pes-software-modal');
  const softwareModalBody = document.createElement('pes-software-modal-body');
  softwareModalBody.data = additionLinks;
  softwareModalBody.ctaItem = ctaItem;
  softwareModalBody.position = position;
  softwareModal.appendChild(softwareModalBody);
  softwareModal.isOpen = true;
  softwareModal.headerLabel = areaTitle;
  softwareModal.addEventListener('didSoftwareModalClose', () => {
    document.body.removeChild(softwareModal);
  });
  document.body.appendChild(softwareModal);
  addRangeClickGAEvent(ctaItem, position);
  send(onlineSoftwareModalClickEvent, type);
};

export { onSoftwareDocumentDialogClick as a, addRangeClickGAEvent as b, getPriorityNumber as g, onDownloadLinkClickGA as o, requestRangeSelectorConfig as r };
